/*
  HORAVI — fix del carrito de Shrine 1.0.4.
  Bug: CartItems declara el class field `lineItemContainer = undefined` y nunca lo asigna,
  pero updateQuantity hace `if (!this.lineItemContainer) return;` justo antes de re-renderizar.
  Resultado: el carrito (drawer y página) nunca actualiza cantidades ni totales tras /cart/change.
  Fix: accessor en el prototipo con fallback a `.js-contents`, y borrado del field propio de la
  instancia en connectedCallback (el field tapa al accessor). Sin tocar el bundle ofuscado.
*/
(function () {
  function patch(tag) {
    var C = customElements.get(tag);
    if (!C) return;
    var proto = C.prototype;
    if (!Object.prototype.hasOwnProperty.call(proto, 'lineItemContainer')) {
      Object.defineProperty(proto, 'lineItemContainer', {
        configurable: true,
        get: function () {
          return this._hvLineItemContainer || this.querySelector('.js-contents') || this;
        },
        set: function (v) {
          this._hvLineItemContainer = v || undefined;
        }
      });
    }
    var origConnected = proto.connectedCallback;
    if (origConnected && !origConnected._hvPatched) {
      var wrapped = function () {
        if (Object.prototype.hasOwnProperty.call(this, 'lineItemContainer') && !this.lineItemContainer) {
          delete this.lineItemContainer;
        }
        return origConnected.apply(this, arguments);
      };
      wrapped._hvPatched = true;
      proto.connectedCallback = wrapped;
    }
    // elementos ya conectados antes de cargar este script
    document.querySelectorAll(tag).forEach(function (el) {
      if (Object.prototype.hasOwnProperty.call(el, 'lineItemContainer') && !el.lineItemContainer) {
        delete el.lineItemContainer;
      }
    });
  }
  patch('cart-items');
  patch('cart-drawer-items');
})();
